
// @ts-nocheck
import locale_fr_45FR_46ts_ce2bf46a from "#nuxt-i18n/ce2bf46a";
import locale_de_45DE_46ts_35be4140 from "#nuxt-i18n/35be4140";

export const localeCodes =  [
  "fr-FR",
  "de-DE"
]

export const localeLoaders = {
  "fr-FR": [
    {
      key: "locale_fr_45FR_46ts_ce2bf46a",
      load: () => Promise.resolve(locale_fr_45FR_46ts_ce2bf46a),
      cache: false
    }
  ],
  "de-DE": [
    {
      key: "locale_de_45DE_46ts_35be4140",
      load: () => Promise.resolve(locale_de_45DE_46ts_35be4140),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/c3646448" /* webpackChunkName: "config_config_46ts_c3646448" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "fr-FR",
      language: "fr-FR",
      localeId: "0190930dda6c71a0b627e5b10970ffc2",
      files: [
        "/opt/buildhome/repo/i18n/src/langs/fr-FR.ts"
      ]
    },
    {
      code: "de-DE",
      language: "de-DE",
      localeId: "2fbb5fe2e29a4d70aa5854ce7ce3e20b",
      files: [
        "/opt/buildhome/repo/i18n/src/langs/de-DE.ts"
      ]
    }
  ],
  defaultLocale: "de-DE",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "./src/langs/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "fr-FR",
    language: "fr-FR",
    localeId: "0190930dda6c71a0b627e5b10970ffc2",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/src/langs/fr-FR.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "de-DE",
    language: "de-DE",
    localeId: "2fbb5fe2e29a4d70aa5854ce7ce3e20b",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/src/langs/de-DE.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/